module.exports = __webpack_public_path__ + "static/media/ill-start-by-opening.7170fc07.mp3";